import { render, staticRenderFns } from "./PcCol.vue?vue&type=template&id=1aa992ad&"
import script from "./PcCol.vue?vue&type=script&lang=js&"
export * from "./PcCol.vue?vue&type=script&lang=js&"
import style0 from "./PcCol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports